/* eslint-disable */
/**
 * @author Leonel Martinez
 * @module catalog
 * @fileoverview `Vuex catalog module`
 */
import { catalogService } from "@/services";
import { MESSAGES, hasNestedProperty } from "@/utils";
import { rootAction } from "../index";

const storage = JSON.parse(
  localStorage.getItem(process.env.VUE_APP_LOCALSTORAGE_DATA)
);

export const catalog = {
  namespaced: true,
  state: {
    isActive: false,
    categories: storage?.categories
  },
  actions: {
    /**
     * @description Loads the catalog.
     */
    GET_CATEGORIES_TREE: async ({ dispatch, commit }) => {
      const response = await catalogService.get_categories_tree();

      if (response.statusText != 'OK') {
        dispatch("snackbar/SHOW_SNACKBAR", MESSAGES.ERROR.CATEGORIES_TREE, rootAction)
        return;
      }

      commit("SET_CATEGORIES_TREE", response.data);
    }
  },
  mutations: {
    SET_CATEGORIES_TREE: (state, categories) => state.categories = categories
  }
};
